import * as Y from 'yjs';
import { withLocalTransaction } from '../transact';
import { yLines } from '../schema';
import { trackCanvasEvent } from '../../analytics';

const LINE_FIELDS = [
    'sourceElementId', 'sourceColumnId', 'targetElementId', 'targetColumnId',
    'sourceCardinality', 'targetCardinality',
    'strokeStyle', 'isReversed',
    'lineType', 'waypoints',
    'color', 'description', 'onUpdateTrigger', 'onDeleteTrigger',
];

function makeYLine(line) {
    const yLine = new Y.Map();
    yLine.set('id', line.id);
    for (const k of LINE_FIELDS) if (line[k] !== undefined) yLine.set(k, line[k]);
    return yLine;
}

export function addLine(doc, line) {
    let ok = false;
    withLocalTransaction(doc, () => { yLines(doc).set(line.id, makeYLine(line)); ok = true; });
    if (ok) trackCanvasEvent('app_canvas_line_add');
}

export function deleteLine(doc, lineId) {
    let ok = false;
    withLocalTransaction(doc, () => {
        const lines = yLines(doc);
        if (!lines.has(lineId)) return;
        lines.delete(lineId);
        ok = true;
    });
    if (ok) trackCanvasEvent('app_canvas_line_delete');
}

export function setLineColor(doc, lineId, color) {
    let ok = false;
    withLocalTransaction(doc, () => {
        const l = yLines(doc).get(lineId); if (l) { l.set('color', color); ok = true; }
    });
    if (ok) trackCanvasEvent('app_canvas_line_color_change');
}

export function setLineConnector(doc, lineId, { direction, relationType }) {
    withLocalTransaction(doc, () => {
        const l = yLines(doc).get(lineId); if (!l) return;
        if (direction === 'from') l.set('sourceCardinality', relationType);
        if (direction === 'to')   l.set('targetCardinality', relationType);
    });
}

export function setLineStrokeStyle(doc, lineId, strokeStyle) {
    let ok = false;
    withLocalTransaction(doc, () => {
        const l = yLines(doc).get(lineId); if (l) { l.set('strokeStyle', strokeStyle); ok = true; }
    });
    if (ok) trackCanvasEvent('app_canvas_line_border_change');
}

export function setLineConnectorsReversed(doc, lineId, reversed) {
    withLocalTransaction(doc, () => {
        const l = yLines(doc).get(lineId); if (!l) return;
        // The renderer derives each end's connector symbol purely from
        // source/target cardinality and has no notion of an isReversed flag, so
        // physically swap the cardinalities to actually flip the connectors.
        // The flag is kept in sync so the menu's toggle state stays correct.
        const src = l.get('sourceCardinality');
        const tgt = l.get('targetCardinality');
        l.set('sourceCardinality', tgt);
        l.set('targetCardinality', src);
        l.set('isReversed', !!reversed);
    });
}

export function setLineOnTrigger(doc, lineId, { triggerType, value }) {
    withLocalTransaction(doc, () => {
        const l = yLines(doc).get(lineId); if (!l) return;
        if (triggerType === 'update') l.set('onUpdateTrigger', value);
        if (triggerType === 'delete') l.set('onDeleteTrigger', value);
    });
}

export function setLineDescription(doc, lineId, description) {
    let ok = false;
    withLocalTransaction(doc, () => {
        const l = yLines(doc).get(lineId); if (l) { l.set('description', description); ok = true; }
    });
    if (ok) trackCanvasEvent('app_canvas_line_description_add');
}
